import React from 'react';
import { AuthenticationConsumer } from '../Authentication/AuthenticationContext';

export default function Logout() {
  return <AuthenticationConsumer>{({ logout }) => logout()}</AuthenticationConsumer>;
}
